import { render, staticRenderFns } from "./ParallaxContainer.vue?vue&type=template&id=3c87b56a&scoped=true&"
import script from "./ParallaxContainer.vue?vue&type=script&lang=ts&"
export * from "./ParallaxContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ParallaxContainer.vue?vue&type=style&index=0&id=3c87b56a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c87b56a",
  null
  
)

export default component.exports